import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/article/list', params)
    },
    save(params) {
        return post('/admin/article/save',params)
    },
    delete(params) {
        return post('/admin/article/delete', params)
    }

}